import { FooterProps } from "@made-people/blueprint-footer";
// import { StrongerLogo } from "../../../assets/logo/Stronger";

export const FooterDefaults: FooterProps = {
  template: "template2",
  navigation: {
    as: ["accordion", "list"],
    headings: {
      variants: {
        headingSize: "sm",
      },
    },
    links: {
      variants: {
        style: "no-underline",
      },
    },
  },
  countrySelector: {
    label: false,
    // variants: {
    //   style: "solid",
    //   rounded: "full",
    // },
  },
  newsletter: {
    settings: {
      template: "template3",
      wrapper: {
        isEnabled: false,
      },
    },
  },
  layout: {
    spacing: {
      y: "none",
    },
  },
  logo: false,
};
